import { Stack } from '@mui/material';
import Typography from '../../../../components/v2/ui/Typography/Typography';
import { formatCNPJ, formatCPF, formatCityWithState } from '../../../../utils/formatters';
import { yupValidateCNPJ, yupValidateCPF } from '../../../../utils/validators';
import { GetCopyOrderCustomers } from '../types/copyOrderModal.types';

interface CustomerOptionsCopyOrderRendererProps {
  customer: GetCopyOrderCustomers;
}

export const CustomerOptionsCopyOrderRenderer = ({
  customer,
}: CustomerOptionsCopyOrderRendererProps) => {
  const format = customer.isPJ ? formatCNPJ : formatCPF;
  const isCpfCnpjValid = customer.isPJ
    ? yupValidateCNPJ(customer.cpfcnpj)
    : yupValidateCPF(customer.cpfcnpj);
  const formattedDoc = customer.cpfcnpj && isCpfCnpjValid ? format(customer.cpfcnpj) : '';

  return (
    <Stack sx={{ width: '100%', minWidth: 0, rowGap: 0.25 }}>
      <Stack direction="row" sx={{ alignItems: 'baseline', gap: 1 }}>
        <Typography noWrap sx={{ flex: 1, minWidth: 0 }}>
          {customer.commercialName}
        </Typography>
        <Typography noWrap sx={{ flexShrink: 0 }}>
          {formatCityWithState({ city: customer.city, state: customer.state })}
        </Typography>
      </Stack>
      <Stack direction="row" sx={{ alignItems: 'baseline', gap: 1 }}>
        <Typography variant="body2" noWrap color="text.secondary" sx={{ flex: 1, minWidth: 0 }}>
          {customer.companyName}
        </Typography>
        <Typography variant="body2" noWrap color="text.secondary" sx={{ flexShrink: 0 }}>
          {formattedDoc}
        </Typography>
      </Stack>
    </Stack>
  );
};
